/*
 * Toolkit scripts
 */

const AnalyticsEvent = require('Scripts/common/analytics-event').default;
const bsCollapse     = require('Scripts/common/bs-collapse');
const JSZip          = require('Vendor/jszip');
const JSZipUtils     = require('Vendor/jszip-utils');
const LoadingButton  = require('Scripts/common/loading-button');
const miuri          = require('Vendor/miuri.js').miuri;
const saveAs         = require('Vendor/file-saver').saveAs;

module.exports = function Toolkit() {
	this.init = function() {
		this.bindEventHandlers();

		// Trigger a URL change, just in case what's in the messages doesn't match the dropdown on page load
		$(".js-url-list").trigger("change");
	}

	this.bindEventHandlers = function() {
		// Use delegated event handlers so that it can deal more easily with AJAX content
		const body = $("body");		
		body.on("click", ".js-preview", this.preview.bind(this));
		body.on("click", ".js-download", this.download.bind(this));
		body.on("click", ".js-download-all", this.downloadAll.bind(this));
		body.on("keyup change", ".js-qr-size,.js-qr-donation-amount", this.onUpdateQrCode.bind(this));

		$('.tabs.nav button').on('shown.bs.tab', this.clickTab.bind(this));
		$(".js-url-list").on("change", this.onSelectUrl.bind(this));
	}

	// Adds a url param for the tabs so that we can link to a particular tab rather than always have the first one open
	this.clickTab = function(e) {
		var url = new miuri();
		url.query("tab", e.target.dataset.bsTarget.replace('#',''));
		window.history.replaceState('', '', url.toString());
	}

	// Open as a preview - only used for emails
	this.preview = function(e) {
		console.log("Toolkit.preview()");

		var trigger = $(e.currentTarget);
		var dlData  = trigger.data();
		var source  = dlData.source;

		// Send tracking to database
		this.track(dlData);

		window.open(dlData.source);
	}

	// Download a single item, either called directly (via button or image link - because of the latter, we have checks for the button) or via a loop in downloadAll
	this.download = function(e, all) {
		console.log("Toolkit.download()");

		var trigger  = $(e.currentTarget || e);
		var button   = trigger.prop("tagName") == "BUTTON" ? new LoadingButton(trigger) : false;
		var dlData   = trigger.data();
		var source   = dlData.source;
		var filename = dlData.filename;
		var pdf      = (dlData.filename || '').endsWith('.pdf');

		// If downloading all, we just return the data
		if(all) {
			return dlData;
		}

		if(button){
			button.disable();
		}

		console.log("Downloading", dlData.campaignId, dlData.assetId);

		// Download (in some cases there is no download, e.g. click some of the copy text/code buttons)
		if(pdf){
			window.open(dlData.source);
		}
		else if(source && filename) {
			saveAs.saveAs(source, filename);
		}

		if(button){
			button.enable();
		}

		// Send tracking to database
		this.track(dlData);
	}

	// Download all (this is always triggered by a button, hence no check if the button exists)
	this.downloadAll = function(e) {
		console.log("Toolkit.downloadAll()");

		var zip        = new JSZip();
		var trigger    = $(e.currentTarget);
		var button     = new LoadingButton(trigger);
		var dlData     = trigger.data();
		var buttons    = $(".btn.js-download");

		button.disable();

		// This loops through the buttons and adds the file to the ZIP, it's done asynronously
		buttons.each((i, button) => {
			var loopedDlData = this.download(button, true);

			var promise = new JSZip.external.Promise((resolve, reject) => {
				JSZipUtils.getBinaryContent(loopedDlData.source, (err, data) => {
					if (err) {
						reject(err);
					} 
					else {
						resolve(data);
					}
				});
			});

			console.log("Downloading into zip", loopedDlData.campaignId, loopedDlData.assetId, loopedDlData.filename);

			zip.file(this.processFilename(loopedDlData.filename), promise, { binary: true });
		});

		// Save the messages into text files
		$("textarea").each((i,textarea) => {
			zip.file(this.processFilename($(textarea).data('filename') || ("message-" + (i+1) + ".txt")), textarea.value);
			console.log("Add social message into zip", textarea.value);
		});

		// Save the link into a text file
		var urls = $(".js-url");
		if(urls.length > 0) {
			var url = urls[0];
			zip.file("url.txt", url.value);
			console.log("Add url into zip", url.value);
		};

		// Once the files have downloaded, zip up and serve to the user
		zip.generateAsync({type:"blob"})
		.then(blob => {
			saveAs.saveAs(blob, dlData.filename || dlData.campaignId);
		})
		.then(() => {
			button.enable();

			// Send tracking to database
			this.track(dlData);
		});
	}

	// If the filename is a duplicate, add a counter so all are included in the download
	this.processFilename = function(filename) {
		this.filenames = this.filenames || [];
		this.filenames.push(filename);
		var count = this.filenames.filter(item => item == filename).length;
		return count > 1 ? filename.replace(".", "-"+count+".") : filename;
	}

	// Track the download by logging on the database (in a timeout to make it async)
	this.track = function(dlData) {
		setTimeout(() => {
			console.log("Toolkit.track()", dlData.campaignId, dlData.assetId);

			var data = {
				campaignId: dlData.campaignId,
				assetId: dlData.assetId,
				widget: dlData.widget,
			};

			// Send to our database
			$.ajax("/toolkit/track", {
				method: 'POST',
				data: data
			});

			// Also send to analytics
			AnalyticsEvent.gtm('ToolkitDownload');
			AnalyticsEvent.heap('toolkitDownload', data);
		}, 0);
	}

	this.onSelectUrl = function(e) {
		console.log("Toolkit.updateUrl()", e.target.value);

		var fullUrl = e.target.value;
		var shortUrl = $(e.target).find("option:selected")[0].innerHTML;

		// Update hidden select (so Clipboard can work)
		$($(e.currentTarget).data("target")).val(fullUrl);

		this.updateUrl(fullUrl, shortUrl);
	}

	// If multiple URLs to choose from, this updates a few bits
	this.updateUrl = function(fullUrl, shortUrl) {		
		// Update social messages and code blocks
		$("textarea:not(.js-ignore)").each((i,textarea) => {
			let regex = /http((?!\&bc=)[^\s\"\'])+/gi;
			finalFullUrl = fullUrl;

			// If it's a code block, then we only want to change the hrefs (previously used regex lookbehind to do this, but not supported by all browsers)
			if(textarea.value.includes("href") && !textarea.value.includes("iframe")) {
				regex = /href=\"http((?!\&bc=)[^\s\"\'])+/gi;
				finalFullUrl = "href=\"" + finalFullUrl;
			}

			textarea.value = textarea.value.replaceAll(regex, finalFullUrl);
		});

		// Update buttons
		$(".js-generator-update a").each((i,btn) => {
			btn.href = btn.href.replaceAll(/http((?!\&bc=)[^\s\"\'])+/gi, fullUrl);
		});

		// Update posters
		$("#posters .js-download").each((i,poster) => {
			let newPosterSource = $(poster).data("source").replaceAll(/(\?|&)customUrl=[^&]*/gi,'');
			newPosterSource += (newPosterSource.indexOf("?") > 0 ? "&" : "?") + "customUrl=" + encodeURIComponent((shortUrl || fullUrl).replace("https://",""));
			$(poster).attr("data-source", newPosterSource);
			$(poster).data("source", newPosterSource);
		});

		// Update QR codes
		$(".js-qr-code").each((i,qr) => {
			const img        = $(qr).find("img")[0];
			const qrMatch    = qr.href.match(/\/qr\/(\d+\/)?/);
			const slashMatch = fullUrl.match(/\w\//);

			// Get the size
			const qrSize = $(".js-qr-size").val();
			const qrPathPrefix = qrSize ? '/qr/' + qrSize + '/' : qrMatch[0];

			let qrImg = fullUrl.replace(slashMatch[0], (slashMatch[0] + qrPathPrefix).replace("//","/"));
			qrImg = qrImg.includes(".png") ? qrImg : qrImg.replace("?", ".png?");
			qrImg = qrImg.includes(".png") ? qrImg : qrImg + ".png?";

			qr.href = qrImg;
			qr.dataset.fullUrl = fullUrl;
			qr.dataset.shortUrl = shortUrl;

			if(img) {
				img.src = qrImg;
				img.title = qrImg;
			}
		});

		// QR code display text
		$(".js-qr-target").each((i, qrTarget) => {
			qrTarget.href = fullUrl;
			qrTarget.innerHTML = fullUrl;
		});

		// This field can only be edited if linking to the Donate Form
		$(".js-qr-donation-amount").prop("disabled", !fullUrl.includes("/donate?"));

		// Hide copy success messages
		bsCollapse(".js-copy-confirm").hide();
	}

	this.onUpdateQrCode = function() {
		console.log("Toolkit.onUpdateQrCode");

		const qrDonationAmount = $(".js-qr-donation-amount").val();
		const firstQr = $(".js-qr-code")[0];

		let fullUrl = firstQr.dataset.fullUrl;
		let shortUrl = firstQr.dataset.shortUrl;

		// Remove existing amounts param
		fullUrl = fullUrl.replaceAll(/&amount=[\d]*/g, '');
		shortUrl = shortUrl.replaceAll(/&amount=[\d]*/g, '');

		if(qrDonationAmount) {
			const amountParam = "&amount=" + qrDonationAmount;
			fullUrl = fullUrl.replace(shortUrl, shortUrl + amountParam); // I've used replace so that it appears before all the UTMs
			shortUrl += amountParam;
		}

		this.updateUrl(fullUrl, shortUrl);
	}

	this.init();
}
